module.exports = __webpack_public_path__ + "static/img/egg_b_08.d5a8d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_08.png
// module id = Hfp8
// module chunks = 1